export default __webpack_public_path__ + "static/media/lisieux04.b5f15b30.jpg";